import { getPublicUrl } from 'helpers/resourcePath';

// localStorage and sessionStorage are scoped to the origin, not to the path. Two App
// Builder instances served under different context paths on the same host (for example
// /tenant-a/app-builder and /tenant-b/app-builder behind one reverse proxy) therefore
// share one store, and an unqualified key lets one instance read and overwrite the
// other's data. Qualify every key holding instance-specific state with the context path.
const storageKey = key => `${key}@${getPublicUrl() || '/'}`;

export default storageKey;
